var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowlinedown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24688 0.722222C6.24688 0.32335 5.91249 0 5.5 0C5.08751 0 4.75312 0.32335 4.75312 0.722222L4.75312 10.5342L1.27501 7.1709C0.98333 6.88885 0.510431 6.88885 0.218756 7.1709C-0.0729188 7.45294 -0.0729188 7.91023 0.218756 8.19227L4.97188 12.7885C5.26355 13.0705 5.73645 13.0705 6.02812 12.7885L10.7812 8.19227C11.0729 7.91023 11.0729 7.45294 10.7812 7.1709C10.4896 6.88885 10.0167 6.88885 9.72499 7.1709L6.24688 10.5342L6.24688 0.722222Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowlinedown);
export default __webpack_public_path__ + "static/media/arrowlinedown.704a26d49167443322aeadbebca55fdd.svg";
export { ForwardRef as ReactComponent };